import Cookies from 'js-cookie'

const TokenKey = 'token'

const UserId = 'user_id'

const IdentityType = 'identity_type'

const UserName = 'user_name'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserId() {
  return Cookies.get(UserId)
}

export function setUserId(userId) {
  return Cookies.set(UserId, userId)
}

export function removeUserId() {
  return Cookies.remove(UserId)
}

export function getIdentityType() {
  return Cookies.get(IdentityType)
}

export function setIdentityType(identityType) {
  return Cookies.set(IdentityType, identityType)
}

export function removeIdentityType() {
  return Cookies.remove(IdentityType)
}

export function getShowUsername() {
	return Cookies.get(UserName)
}

export function setShowUsername(userName) {
	return Cookies.set(UserName, userName)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js